















import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class MediaItem extends Vue {
    @Prop() media!: any
}
